import React from "react";
import { Chip } from "@mui/material";
import { BADGE_COLORS, getBadgeStyles } from "../../../../components/ui/badgeColors";
import { formatDiferencia } from "../../utils/formatters";

/**
 * Badge de la diferencia de una línea de inventario entre el stock teórico y
 * la cantidad contada. Distingue cuatro casos:
 * - Sin contar todavía (GRAY, "Pendiente")
 * - Cuadra exacto (GREEN, "Cuadra")
 * - Falta (RED, número en negativo)
 * - Sobra (AMBER, "+N")
 *
 * Usa formatDiferencia (utils/formatters.js) para el texto de falta/sobra, y
 * calcularDiferencia (helpers/transformers.js) es responsabilidad de quien
 * llama: este componente solo pinta {diferencia, contado} ya calculados, no
 * vuelve a calcular nada.
 *
 * Puro y sin estado propio: se repite por línea en listas potencialmente
 * largas (modo resultado de DetalleInventario, TASK-016), de ahí React.memo.
 */
const DiferenciaBadge = React.memo(({ diferencia, contado }) => {
    if (!contado) {
        return <Chip label="Pendiente" size="small" sx={getBadgeStyles(BADGE_COLORS.GRAY)} />;
    }

    if (diferencia === 0) {
        return <Chip label="Cuadra" size="small" sx={getBadgeStyles(BADGE_COLORS.GREEN)} />;
    }

    const color = diferencia < 0 ? BADGE_COLORS.RED : BADGE_COLORS.AMBER;
    return <Chip label={formatDiferencia(diferencia)} size="small" sx={getBadgeStyles(color)} />;
});

DiferenciaBadge.displayName = "DiferenciaBadge";

export default DiferenciaBadge;
